<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/packages/package_attrs.yml"
  lang="yaml"
></i18n>
<template>
  <div class="grid grid-cols-6 gap-x-4 gap-y-6 py-3">
    <div class="col-span-6">
      <label class="block text-sm font-medium text-gray-700">{{
        new_package_group
          ? $t("labels.new_package_group")
          : $t("model.package.package_group")
      }}</label>
      <div class="flex">
        <div
          v-show="new_package_group"
          class="grid grid-cols-1 md:grid-cols-2 w-full gap-x-4"
        >
          <input
            type="text"
            :value="package_item.package_group.pg_code"
            @input="$emit('update:package_group:pg_code', $event.target.value)"
            :placeholder="$t('model.package_group.pg_code')"
            class="mt-1 focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block w-full shadow-sm sm:text-sm border-slate-300 rounded-md"
          />
          <input
            type="text"
            :value="package_item.package_group.thermo_code"
            @input="
              $emit('update:package_group:thermo_code', $event.target.value)
            "
            :placeholder="$t('model.package_group.thermo_code')"
            class="mt-1 focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block w-full shadow-sm sm:text-sm border-slate-300 rounded-md"
          />
        </div>
        <select-form
          v-if="package_groups.length > 1"
          v-show="!new_package_group"
          class="custom-tailwind-select w-full"
          :options="package_groups"
          v-model="package_group_id"
          label="pg_code"
        />
        <div class="content-data w-full" v-else-if="package_groups.length == 1">
          {{ package_groups[0]?.pg_code }}
        </div>

        <button
          class="p-2 flex items-start md:items-center mt-4 md:mt-1"
          @click.prevent="new_package_group = !new_package_group"
        >
          <i
            :class="[
              'fa-solid fa-lg pl-1 text-blue-700',
              new_package_group ? 'fa-minus' : 'fa-plus',
            ]"
          ></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PackageGroup",
  components: {},
  data() {
    return {
      package_group_id: null,
      new_package_group: false,
    };
  },
  props: {
    package_item: {
      type: Object,
      required: true,
    },
    package_groups: {
      required: true,
    },
  },
  mounted() {
    if (
      this.package_item.package_group_id == null &&
      this.package_item.package_group.pg_code
    ) {
      this.new_package_group = true;
    }

    this.setDefaultValue();
  },
  updated() {
    this.package_group_id = this.package_item.package_group_id;
  },
  methods: {
    setDefaultValue() {
      if (this.package_groups.length == 1) {
        this.package_group_id = this.package_groups[0].id;
      }
    },
  },
  watch: {
    package_group_id: function (new_value) {
      this.$emit("update:package_group_id", new_value);
    },
    new_package_group: function (new_value) {
      if (new_value) {
        this.$emit("update:package_group_id", null);
      } else {
        this.$emit("update:package_group:pg_code", null);
        this.$emit("update:package_group:thermo_code", null);
      }
    },
    package_groups: {
      handler: function () {
        this.setDefaultValue();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
